var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info",class:{visible: _vm.visible}},[(_vm.mobile)?_c('p',[_vm._v("Använd två fingrar för att navigera i kartan.")]):_c('p',[_vm._v("Håll in CTRL för att zooma i kartan.")])])}
var staticRenderFns = []

export { render, staticRenderFns }